export const DEFAULT_LOCATION = {
  lat: 48.856614,
  lng: 2.3522219,
};

export const PATTERN_LINK_GOOGLE_MAP = /!3d([0-9.-]*)!4d([0-9.-]*)/;
export const PATTERN_LINK_API_MAP = /query=([0-9.,-]*)/;

export const GOOGLE_MAP_ZOOM = 14;
